import Project from '../project';

/**
 * Create the action
 */

const { thunk, request, success, error } = Project.store((data, fetch) => {
  // We use this to store a project into redux from the frontend without hitting the backend
  if (data.fromLocal === true) {
    return Promise.resolve({ data });
  }

  if (data.fromShare === true) {
    return fetch.post('project-from-share', data);
  }

  if (data.copyProject === true) {
    return fetch.post('project-copy', data);
  }

  if (data.duplicateProjectAndTheme === true) {
    return fetch.post('project-and-theme-duplicate', data);
  }

  if (data.processMlImage === true) {
    // Create an object of formData
    const formData = new FormData();

    // Update the formData object
    formData.append('image', data.image);

    return fetch.post(`imagetest/${data.theme_id}`, formData);
  }

  // Prepare request
  const formData = new FormData();

  Object.keys(data).map(function (key) {
    if (key == 'process') {
      formData.append(key, JSON.stringify(data[key]));
    } else if (key == 'image') {
      if (data[key].constructor === File) {
        formData.append(key, data[key]);
      }
    } else if (key == 'is_public') {
      formData.append(key, data[key] == false ? 0 : 1);
    } else {
      formData.append(key, data[key]);
    }
  });

  return fetch.post('/projects', formData);
});

/**
 * Export the components
 */

export { thunk as default };
export { request, success, error };
